import {StyleSheet} from 'react-native';
export default StyleSheet.create({
  root: {
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  disabled: {
    opacity: 0.5,
  },
});
